import React, { Component } from "react";
import { Container, Flex, Tile, Title, TilesContainer, Text } from "../ui";
import { TeamBox } from "../components";
import { WindowSize } from "react-fns";
import styled from "styled-components";
import { team } from "../team";
import posed from "react-pose";
import { WHOWEARE } from "../assets/svg";
import InlineSVG from "svg-inline-react";
import { Marquee } from "../ui/animations";

const TeamContainer = styled(Container)`
  padding-bottom: 10rem;
  position: relative;
  .header--content {
    width: 50%;
    @media (max-width: 1400px) {
      width: auto;
      justify-content: space-around;
    }
    @media (max-width: 768px) {
      flex-direction: column;
    }
  }
  .team--members {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    @media (max-width: 1200px) {
      justify-content: center;
    }
  }
`;

const MemberContainer = posed.div({});

class Team extends Component {
  state = { isOpen: false };

  componentDidMount() {
    setTimeout(this.toggle, 100);
  }

  toggle = () => this.setState({ isOpen: !this.state.isOpen });
  render() {
    const { isOpen } = this.state;
    return (
      <WindowSize
        render={({ width }) => (
          <div style={{ width: "100%" }}>
            <TilesContainer style={{ height: "100%" }} svgTop="0%">
              {width >= 769 ? (
                <>
                  <div className="svg--wrapper">
                    <InlineSVG src={WHOWEARE} />
                  </div>
                  <Tile style={{ flex: 0.5 }} />
                  <Tile />
                  <Tile />
                  <Tile />
                  <Tile />
                  <Tile />
                  <Tile style={{ flex: 0.5 }} />
                </>
              ) : (
                <>
                  <div className="svg--wrapper">
                    <InlineSVG src={WHOWEARE} />
                  </div>
                  <Tile />
                  <Tile />
                  <Tile />
                </>
              )}
            </TilesContainer>
            <TeamContainer padding="5rem 2rem">
              <Flex column justifyContent="space-between" fillHeight>
                <Flex
                  justifyContent="space-between"
                  className="header--content"
                >
                  <Flex width="auto" column>
                    <Title>Team</Title>
                  </Flex>
                  <Text>
                    We believe in individuals. Individuals that we work with on
                    a day to day basis. But more than that, we believe in a
                    team. A team that consists of people willing to place that
                    same team above themselves.
                  </Text>
                </Flex>
                <div className="team--members">
                  {team.map((member, key) => (
                    <MemberContainer key={key} pose={isOpen ? "open" : "closed"}>
                      <TeamBox
                        person={member}
                        key={key}
                        i={key}
                        pose="visible"
                      />
                    </MemberContainer>
                  ))}
                </div>
              </Flex>
            </TeamContainer>
          </div>
        )}
      />
    );
  }
}
export default Team;
